
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/chameleon",
      function () {
        return require("private-next-pages/destinations/chameleon.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/chameleon"])
      });
    }
  